<template>
  <div class="dashboard">
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-body">
              <h1 class="card-title">Brewing Dashboard
                <router-link class="btn btn-secondary btn-sm"
                             v-if="loggedIn"
                             :to="{ name: 'streams'}">Manage</router-link>
              </h1>
              <BaseLoader :loading="loading"/>

              <brew-timeline-component />

              <div class="brew-sessions">
                <h2>Currently brewing</h2>

                <ul v-if="activeStreams" class="stream-list">
                  <li class="stream-item" v-for="stream in activeStreams">
                    <brew-session-component :brew-session-id="stream.brewSessionId" :stream-name="stream.name"></brew-session-component>
                  </li>
                </ul>
                <div v-if="!loading && activeStreams.length === 0">
                  <p class="lead">
                    There are no active beer fermentations at this time &#127866;
                  </p>
                  <p>Go to <router-link :to="{ name: 'home'}">brew library</router-link> to see the latest brews</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  import RecipesList from "../components/RecipesList.vue";
  import BrewSessionComponent from "../components/BrewSessionComponent";
  import BrewTimelineComponent from "../components/BrewTimelineComponent";
  import { EventBus } from '../lib/event-bus.js';
  import { HTTP } from '../lib/http';

  export default {
    name: "dashboard",
    components: {
        RecipesList,
        BrewSessionComponent,
        BrewTimelineComponent
    },
    data() {
      return {
        streams: undefined,
        errors: null,
        loading: true,
        loggedIn: false
      };
    },
    methods: {
        fetchStreams() {
            HTTP.get("streams")
                .then(response => {
                    this.streams = response.data.data;
                })
                .catch(err => {
                    this.errors = [err.response.data.message];
                })
                .then(() => {
                    this.loading = false;
                });
        },
    },
    computed: {
      activeStreams() {
          return _(this.streams).filter((stream) => stream.active).value();
      }
    },
    beforeMount() {
        this.loggedIn = !!localStorage.username;
        EventBus.$on('logged-in', val => { this.loggedIn = val; });
    },
    mounted() {
        this.fetchStreams();
    }
  };
</script>

<style scoped lang="scss">
  h1 {
    .btn {
      font-size: .5em;
      float: right;
    }
  }

  .brew-sessions {


    .stream-list {
      list-style-type: none;
      padding: 0;
      margin: 0;

      .stream-item {
        margin-bottom: 3em;
      }
    }
    @media (min-width: 575.98px) {
     .stream-list {
       display: flex;
       flex-wrap: wrap;

       .stream-item {
         margin-right: 5%;
       }
     }
    }
  }
</style>
